// src/ui/BlockedUsersModal.jsx — who I've blocked, and the way back.
//
// The list is `users/{me}.blockedUsers`, the phone's own array, watched live —
// so blocking on the phone shows here within the snapshot, and unblocking here
// clears it there. Unblock writes both sides of the mirror (my array and the
// `blockedBy` entry on their doc), exactly as services/blocking.js does for the
// in-chat button.

import React, { useEffect, useState } from 'react';
import Avatar, { resolveName } from './Avatar';
import { X, Slash, Check } from './icons';
import { getUserProfile } from '../services/users';
import { unblockUser } from '../services/blocking';

export default function BlockedUsersModal({ myUid, blocking, onClose }) {
  const uids = [...(blocking?.byMe || [])];
  const [people, setPeople] = useState({});
  const [busy, setBusy] = useState('');
  const [done, setDone] = useState({});

  useEffect(() => {
    let live = true;
    uids.forEach((u) => {
      if (people[u]) return;
      getUserProfile(u).then((p) => { if (live && p) setPeople((prev) => ({ ...prev, [u]: p })); });
    });
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uids.join(',')]);

  const lift = async (uid) => {
    setBusy(uid);
    try {
      await unblockUser(myUid, uid);
      setDone((d) => ({ ...d, [uid]: true }));
    } catch {}
    setBusy('');
  };

  return (
    <div className="ng-modal" onClick={onClose}>
      <div className="ng-card bu-card" onClick={(e) => e.stopPropagation()}>
        <div className="ng-head">
          <b><Slash width={16} height={16} /> Blocked users</b>
          <button className="icon-btn" onClick={onClose} aria-label="Close"><X /></button>
        </div>

        <div className="ng-body">
          {uids.length === 0 ? (
            <div className="bu-empty">
              <span className="bu-empty-ico"><Slash width={22} height={22} /></span>
              <b>Nobody is blocked</b>
              <i>People you block from a chat or from your phone show up here.</i>
            </div>
          ) : (
            <>
              <div className="bu-note">
                Blocked people can’t message or call you, and you won’t see their
                presence. This list is the same one on your phone.
              </div>
              {uids.map((u) => (
                <div className="ng-row bu-row" key={u}>
                  <Avatar profile={people[u]} size="sm" myUid={myUid} />
                  <span className="ng-row-who">
                    <b>{people[u] ? resolveName(people[u]) : 'Allo user'}</b>
                    <i>{people[u]?.username ? `@${people[u].username}` : ''}</i>
                  </span>
                  {done[u] ? (
                    <span className="bu-done"><Check width={13} height={13} /> Unblocked</span>
                  ) : (
                    <button className="ci-chip" disabled={busy === u} onClick={() => lift(u)}>
                      {busy === u ? 'Unblocking…' : 'Unblock'}
                    </button>
                  )}
                </div>
              ))}
            </>
          )}
        </div>

        <div className="ng-foot">
          <span className="ng-count">{uids.length} blocked</span>
          <button className="lg-go slim" onClick={onClose}>Done</button>
        </div>
      </div>
    </div>
  );
}
